<template>
  <div class="max-w-[600px] mx-auto">
    <!--
      The brown CTA pill of the sign-in, registration and onboarding flows. The
      design system owns the fill, the radius and the disabled look; the text
      rung is kept at 18px (`text-text-body-lg`) because these full-width CTAs
      read as page actions, not as the 14px label the DS size scale assumes.
    -->
    <DsButton
      variant="secondary"
      shape="pill"
      size="56"
      button-type="submit"
      :disabled="disabled"
      :loading="loading"
      class="w-full !text-text-body-lg"
    >
      {{ text }}
    </DsButton>
  </div>
</template>

<script>
import { Button as DsButton } from '@team-hogc/hogc-one-design-system';

export default {
  components: {
    DsButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
